export default __webpack_public_path__ + "static/media/loader.285798e7.gif";